import { Component, input } from '@angular/core';
import { BarInputs } from '@charts';
import { BarChartComponent } from "../bar-chart";

@Component({
  selector: 'ui-rsabt-wave-quality-harmonics-chart',
  imports: [BarChartComponent],
  template: ` <ui-bar-chart [barInputs]="barInputs()" /> `,
})
export class RsabtWaveQualityHarmonicsChartComponent {
  barInputs = input.required<BarInputs>();
}
